import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewDidEnter } from '@ionic/react'
import { MktButton, PasswordInput, VerifyCodeInput, UseHeader, NickNameInput, ForgetModal } from '@cps'
import { modalLayer, toast, useHistoryNew, getVisitorInfo } from '@utils'
import MktController from 'controllers/mktController'
import { memberMobx } from '@mobxStore'
import './index.scss'

// interface
interface IProps extends IPage, RouteComponentProps {
}

const verifyCodeRegister = memberMobx.verifyCodeTypes.register

const Login: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const {
    isReg,
    type,
    account,
    countryCode
  } = match.params as any

  const [verifyCodeInfo, setVerifyCodeInfo] = useState<any>({})
  const [passwordInfo, setPasswordInfo] = useState<any>({})
  const [nickInfo, setNickInfo] = useState<any>({})
  const [avatarUrl, setAvatarUrl] = useState<string>('')
  // Data Method

  // Component Event
  const goBack = () => {
    history.goBack()
  }
  const handleForget = () => {
    modalLayer(ForgetModal, {
      type,
      account,
      countryCode,
    }, 'forgetModal').then(() => {
      MktController.loginEnd(history)
    })
  }
  const handleLogin = () => {
    if (!nickInfo.inputValue && isReg === '0') {
      toast({ message: i18n.t('mkt.common.tipNickName') })
      return
    }
    if (!verifyCodeInfo.inputValue && isReg === '0') {
      toast({ message: i18n.t('mkt.common.tipCode') })
      return
    }
    if (window.bo === 'cn') {
      if (!passwordInfo.inputValue) {
        toast({ message: i18n.t('mkt.common.tipPassword') })
        return
      } else if (!passwordInfo.valid) {
        toast({ message: i18n.t('mkt.common.tipPassword') })
        return
      }
    }
    const params: any = {
      captcha: verifyCodeInfo.inputValue,
      nickName: nickInfo.inputValue,
      avatarUrl,
    }
    if (window.bo === 'cn') {
      params.loginPwd = passwordInfo.inputValue
    }
    if (type === 'email') {
      params.email = account
    } else if (type === 'mobile') {
      params.mobile = account
      params.countryCode = Number(countryCode)
    }
    memberMobx.login('normal', params).then((success: any) => {
      if (success) {
        toast({ message: i18n.t('mkt.common.loginSuccess') })
        goBack()
      }
    })
  }
  useIonViewDidEnter(() => {
    setPasswordInfo({})
    setVerifyCodeInfo({})
    const visitorInfo: any = getVisitorInfo()
    if (visitorInfo) {
      setNickInfo({
        inputValue: visitorInfo.name,
      })
      setAvatarUrl(visitorInfo.avatar || '')
    } else {
      setNickInfo({})
      setAvatarUrl('')
    }
  })
  return (
    <IonPage className='password-page'>
      <IonContent className='page-content'>
        <UseHeader onBack={goBack}></UseHeader>
        {
          isReg === '0' && (
            <div className='panel'>
              <div className='title'>{i18n.t('mkt.member.newMemberReg')}</div>
              <div className='des'>
                <span>  {i18n.t('mkt.member.isSendCode', { name: type === 'email' ? account : `+${countryCode} ${account}` })},{i18n.t('mkt.member.passwordDes')}</span>
              </div>
              <div className='body'>
                <NickNameInput defaultValue={nickInfo.inputValue} onChange={(val: any) => setNickInfo(val)}></NickNameInput>
                <div className='input-item'>
                  <VerifyCodeInput autoSend codeType={verifyCodeRegister} account={account} accountType={type} countryCode={countryCode} onChange={(val: any) => setVerifyCodeInfo(val)} />
                </div>
                <input type='text' style={{ opacity: 0, height: 0, border: 'none', position: 'fixed', left: 0, bottom: 0 }} />
                {
                  window.bo === 'cn' &&
                    <div className='input-item'>
                      <PasswordInput onChange={(val: any) => setPasswordInfo(val)} />
                    </div>
                }
              </div>
              <div className='footer'>
                <MktButton text={i18n.t('mkt.common.confirm')} onClick={handleLogin} />
              </div>
            </div>
          )
        }
        {
          isReg === '1' && (
            <div className='panel'>
              <div className='title'>{i18n.t('mkt.common.tipPassword2')}</div>
              <div className='body'>
                <PasswordInput onChange={(val: any) => setPasswordInfo(val)} />
              </div>
              <div className='footer'>
                <MktButton disabled={!passwordInfo.valid} text={i18n.t('common.loginIn')} onClick={handleLogin} />
              </div>
              <div className='extra'>
                <span className='reg-span' onClick={handleForget}>{i18n.t('pageName.forget')}</span>
              </div>
            </div>
          )
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(Login)
